import axios from '@/helpers/http-common';
import { Contact, Comment } from '@/types';


const index = (
    page: number = 1,
    perPage: number = 10,
    search: string = '',
    archived: boolean = false,
    sortBy: string = '',
    sortDesc: boolean = false,
) => {
    return axios.get(`/parties?\
page=${page}&\
per_page=${perPage}&\
search=${search}&\
archived=${archived}&\
order_by=${sortBy}&\
order_desc=${sortDesc}`);
};

const select = (search: string = '', limit: number = 10) => {
    return axios.get(`/select/parties?search=${search}&limit=${limit}`);
};

const show = (id: string) => {
    return axios.get(`/parties/${id}`);
};

const put = (id: string, party: any) => {
    return axios.put(`/parties/${id}`, { party });
};

const post = (party: any) => {
    return axios.post(`/parties/`, { party });
};

const deleteParty = (id: string) => {
    return axios.delete(`/parties/${id}`);
};

const getComments = (id: string) => {
    return axios.get(`/parties/${id}/comments`);
};

const postComment = (id: string, partyComment: Comment) => {
    return axios.post(`/parties/${id}/comments`,  { party_comment: partyComment });
};

const putComment = (id: string, partyComment: Comment) => {
    return axios.put(`/party/comments/${id}`,  { party_comment: partyComment });
};

const getAttachments = (id: string) => {
    return axios.get(`/parties/${id}/attachments`);
};

const postAttachment = (id: string, file: any) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return axios.post(`/party/comments/${id}/attachments`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const downloadAttachment = (id: string, filename: string) => {
    return axios.get(`/party/attachments/${id}`, {
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    });
};

const getContacts = (id: string) => {
    return axios.get(`/parties/${id}/contacts`);
};

const postContact = (id: string, partyContact: Contact) => {
    return axios.post(`/parties/${id}/contacts`,  { party_contact: partyContact });
};

const putContact = (id: string, partyContact: Contact) => {
    return axios.put(`/party/contacts/${id}`,  { party_contact: partyContact });
};

export const partyService = {
    index,
    select,
    show,
    post,
    put,
    deleteParty,
    getComments,
    getContacts,
    postComment,
    postContact,
    putComment,
    putContact,
    getAttachments,
    postAttachment,
    downloadAttachment,
};
